import React from "react";
import { connect } from "react-redux";
import { Spin, Empty, Avatar, Flex, Badge, Tooltip, Collapse } from "antd";
import { FormatTimeAgo } from "../../helpers/formatTimeAgo";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { calculateDaysUsed, formatPromptPayNumber, getCalculateRemainingLimitToday } from "../../utils"; /// , getFormattedTimezone
import { CopyTextToClipboard } from "../../helpers/copy";
import { timeRange } from "../../Data/BankData";
import { tagsColorBalance } from "../../helpers/tagsBage";
import { getValidateMerchant } from "../../config/authsave";


/**
 * Functional Component สำหรับแสดงรายละเอียดบัญชีถอนเงิน
 * @param {object} item - ข้อมูลบัญชีแต่ละรายการ
 * @param {boolean} loadingBankAccounts - สถานะการโหลดข้อมูล
 * @param {function} get_balance_summerys - ฟังก์ชันสำหรับดึงยอดคงเหลือ
 * @param {Array} withdrawUsage - withdrawUsage
 * @param {function} t - ฟังก์ชันสำหรับจัดการภาษา
 */
const BankAccountItem = ({
  item,
  loadingBankAccounts,
  get_balance_summerys,
  t,
  no,
  averageTime,
  averageUpdateTime,
  withdrawUsage,
  witdrow_minlimit
}) => {

  let type = item?.bank?.bank_id === "kbank" && item?.accountType === "withdrawal";

  let isArray = Array.isArray(withdrawUsage) ? withdrawUsage : [];

  let activeKey = ["1"];
  let { id } = getValidateMerchant() || {};

  let length = isArray.length;
  let show = length > 0 ? true : false;

  let limit_Left = parseFloat(item?.limit_Left || 0).toFixed(2);

  let { remainingLimit, totalWithdrawnToday } = getCalculateRemainingLimitToday(isArray, limit_Left) || {};

  const items = isArray.map((row, index) => ({
    key: `${index + 1}`,
    label: (<>{row.merchantName} ({row.merchantId}) </>),
    extra: (<>{Intl.NumberFormat().format(row?.totalWithdraw)}</>),
    disabled: length === 0 ? true : false,
    style: { background: id === row.merchantId ? "#e6f4ff" : 'none', borderBottom: "none" },
    showArrow: false,
  }));

  return (
    <div className="card" style={{ padding: "15px", marginBottom: 20 }}>
      <div className="body fs-sm-12">
        <div className="row clearfix mb-2">
          <div className="col-lg-6 col-md-12 col-sm-12 mb-3 fs-sm-11">
            <div className="receipt-left">
              <Flex gap={5} align="center" direction="horizontal" size={16}>
                <Avatar size={24} src={item?.bank.imageUrl} />
                <h5
                  title={t(item?.bank?.bank_id)}
                  className="text-truncate fs-sm-18"
                  style={{ marginBottom: 0, maxWidth: 300 }}
                >
                  {t(item?.bank?.bank_id)} {" "}
                </h5>
              </Flex>
              <div
                className="mt-3 mb-1"
                title={item?.accountName}
                style={{ maxWidth: 300 }}
              >
                <b>{t("account name")}</b>
                <>
                  <code style={{ color: "rgb(90 90 90)" }}>
                    {" "}
                    : {item?.accountName}
                  </code>
                </>
              </div>
              <div className="">
                <b>{t("account number")}</b>
                <code
                  style={{ cursor: "copy", color: "rgb(90 90 90)" }}
                  onClick={() => CopyTextToClipboard(item?.accountNumber)}
                >
                  {" "}
                  : {formatPromptPayNumber(item?.accountNumber)}
                </code>
              </div>
              <div className="d-none">
                <b>{t("ประเภทธุรกรรม")}</b>
                <code style={{ color: "rgb(90 90 90)" }}>
                  {" "}
                  : {type ? t("WithdrawalManual") : t("system_auto")}
                </code>
              </div>
              <div className="">
                <b>{t("Min Payout")}</b>
                <code style={{ color: "rgb(90 90 90)" }}>
                  {" "}
                  : {witdrow_minlimit}
                </code>
              </div>
              <div className="">
                <b>{t("opening hours")}</b>
                <code style={{ color: "rgb(90 90 90)" }}>
                  {" "}
                  : {timeRange(item?.bank?.bank_id, "withdrawal", t) || "-"}
                </code>
              </div>
              <div className={`${!averageTime && "d-none"}`}>
                <Tooltip placement="topRight" title={<>{`${t("latest Update", { date: moment(averageUpdateTime).format("HH:mm:ss") })}`}</>}>
                  <b>{t("average time / entries")}</b> {" : "}
                  <code id="averageTime" style={{ color: "rgb(90 90 90)" }}>
                    {averageTime}
                  </code>
                </Tooltip>

              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 fs-sm-11 text-right">
            <br className="hidden-sm" />
            <br className="hidden-sm" />
            <br className="hidden-sm" />
            <div className="mb-0 ">
              <h4 className="fs-sm-16">
                {loadingBankAccounts ? (
                  <i
                    className="bx bx-loader-circle bx-spin"
                    style={{ color: "#888" }}
                  ></i>
                ) : (
                  <>
                    <span
                      id="balance-payout"
                      data-bank-id={item?.id}
                      data-original={item?.balance}
                    >
                      {!loadingBankAccounts ? (
                        <code style={{ color: tagsColorBalance(item?.balance) }}>
                          ฿ {Intl.NumberFormat().format(item?.balance)}
                        </code>
                      ) : (
                        <i className="bx bx-loader-circle bx-spin"></i>
                      )}
                    </span>{" "}
                  </>
                )}
                <small>
                  {!loadingBankAccounts && (
                    <>
                      {" "}
                      <i
                        className="bx bx-revision  icon-hover"
                        style={{ fontSize: "18px", cursor: "pointer", opacity: 0.5 }}
                        onClick={() => get_balance_summerys(item?.id)}
                      />
                    </>
                  )}
                </small>
              </h4>
            </div>
            <p className="mb-0">
              <i
                className=""
                style={{ fontSize: 12, opacity: 0.4 }}
                children={<>{t("ACC_WIT_No", { counter: no })}</>}
              />
            </p>
            < br />
            <p className="mb-0 fs-13 fs-sm-11" style={{ display: show || limit_Left > 0 ? "block" : "none" }}>
              {t("Amount withdrawn today")} :{" "}
              <code style={{ color: "rgb(90 90 90)" }}>
                {totalWithdrawnToday}
              </code>
            </p>
            <p className="mb-0 fs-13 fs-sm-11" style={{ display: limit_Left > 0 ? "block" : "none" }}>
              {t("Remaining Limit today")} :{" "}
              <code style={{ color: "rgb(90 90 90)" }}>
                {remainingLimit}
              </code>
            </p>
            <p className="mb-0 fs-13 fs-sm-11">
              {t("days used")} : {calculateDaysUsed(item?.created_at)}{" "}
            </p>

            <div className="fs-13 fs-sm-11">
              <b>{t("updatedAt")} :</b>{" "}
              <Tooltip
                placement="top"
                title={moment(item?.updated_at)
                  .locale("th")
                  .format("YYYY/MM/DD HH:mm:ss")}
              >
                <b>{FormatTimeAgo(item?.updated_at)}</b>
              </Tooltip>
            </div>
          </div>
        </div>
        {show && <>
          <Collapse
            defaultActiveKey={length <= 0 ? [] : activeKey}
            className="fs-sm-11"
            style={{
              border: "none",
              color: "rgb(90 90 90)",
              fontWeight: "600",
            }}
            items={[
              {
                key: "1",
                label: t("merchant"),
                children:
                  length <= 0 ? (
                    <Empty />
                  ) : (
                    <Collapse
                      expandIconPosition={"end"}
                      items={items}
                      collapsible="disabled"
                      accordion
                      className="scrollbar fs-sm-11"


                      style={{
                        border: "none",
                        color: "rgb(90 90 90)",
                        background: "rgba(0, 0, 0, 0)",
                        maxHeight: 400,
                      }}

                    />
                  ),
                extra: <>{t("Total Account Withdrawal (Today)")}</>,
                showArrow: false,
              },
            ]}
          />
        </>}

      </div>
    </div>
  );
};

class WithdrawStatusBank extends React.Component {
  /**
   * ฟังก์ชันจัดการข้อมูลบัญชีและแสดงผล
   * @param {Array} accWithdrawal - ข้อมูลบัญชีทั้งหมด
   * @param {Array} withdrawUsage - withdrawUsage
   */
  handleDataAccount = (accWithdrawal, withdrawUsage) => {
    const { averageTime, averageUpdateTime, t, get_balance_summerys, spinnerID, witdrow_minlimit } = this.props; // , handleReload

    const withdrawal = Array.isArray(accWithdrawal)
      ? accWithdrawal.filter(
        (o) => o?.accountType === "withdrawal" && o?.status_bank === "Active",
      )
      : [];

    if (withdrawal?.length === 0) {
      return (
        <div className="card" style={{ padding: "15px", marginBottom: 0 }}>
          <div className="body">
            <Empty description={t("No data")} />
          </div>
        </div>
      );
    }

    return withdrawal?.map((item, key) => (
      <React.Fragment key={item?.id}>
        <Spin spinning={item?.id === spinnerID}>
          <BankAccountItem
            item={item}
            loadingBankAccounts={item?.id === spinnerID}
            get_balance_summerys={get_balance_summerys}
            t={t}
            no={key + 1}
            averageTime={averageTime}
            averageUpdateTime={averageUpdateTime}
            withdrawUsage={withdrawUsage}
            witdrow_minlimit={witdrow_minlimit}
          />
        </Spin>
      </React.Fragment>
    ));
  };

  render() {
    const { activeAccountData, t, withdrawUsage } = this.props;

    return (
      <Badge.Ribbon
        text={
          <span style={{ color: "#fff", fontWeight: "500" }}>
            {t("Withdrawal")}
          </span>
        }
        color="#f5222d"
      >
        {this.handleDataAccount(activeAccountData, withdrawUsage)}
      </Badge.Ribbon>
    );
  }
}

const mapStateToProps = ({ UIElementsReducer }) => ({});

export default connect(
  mapStateToProps,
  {},
)(withTranslation()(WithdrawStatusBank));
